export const normalizeDueDateForApi = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';

    const compact = raw.replace(/\s+/g, '');
    if (/^\d{4}-\d{2}-\d{2}$/.test(compact)) {
        return `${compact}T23:59:00+00:00`;
    }
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(compact)) {
        const [month, day, year] = compact.split('/');
        const paddedMonth = month.padStart(2, '0');
        const paddedDay = day.padStart(2, '0');
        return `${year}-${paddedMonth}-${paddedDay}T23:59:00+00:00`;
    }
    return raw;
};

const getCalendarDateParts = (value) => {
    const raw = String(value || '').trim();
    const compact = raw.replace(/\s+/g, '');
    const isoMatch = compact.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
        return {
            year: Number(isoMatch[1]),
            month: Number(isoMatch[2]),
            day: Number(isoMatch[3]),
        };
    }
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(compact)) {
        const [month, day, year] = compact.split('/');
        return {
            year: Number(year),
            month: Number(month),
            day: Number(day),
        };
    }
    return null;
};

export const parseDueDate = (value) => {
    const parts = getCalendarDateParts(value);
    if (!parts) return null;

    const parsed = new Date(parts.year, parts.month - 1, parts.day, 23, 59, 0);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDueDate = (value) => {
    const parts = getCalendarDateParts(value);
    if (!parts) return 'Not set';
    const parsed = new Date(parts.year, parts.month - 1, parts.day);
    return parsed ? parsed.toLocaleDateString() : 'Not set';
};

export const formatDueDateTime = (value) => {
    const parsed = parseDueDate(value);
    if (!parsed) return 'Not set';
    return `${parsed.toLocaleDateString()} ${parsed.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
};

export const isPastDue = (value) => {
    const parsed = parseDueDate(value);
    return parsed ? parsed < new Date() : false;
};
